import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
};
default_1 = __decorate([
    Component
], default_1);
export default default_1;
